export enum EntityTypes {
  MasterInputInstruction = 0,
  MasterUseInstruction = 1,
  MasterOperation = 2,
  Item = 3,
  Resource = 4,
  Material = 5,
  MasterOutputInstruction = 6,
  General = 7,
  IntermediateItem = 8,
  ItemGroup = 9,
  ProcessSelector = 10,
  TaskSelector = 11,
  Process = 12,
  Classificator = 13,
  Property = 14,
  Configuration = 15,
  OrderLine = 16
}
